import React, { FC, ReactNode } from 'react';
import { DialogActions } from '@mui/material';
import { useStyles } from 'components/shared/dialogs/StepModal/StepModal.styles';

export const StepActions: FC<{ children?: ReactNode }> = ({ children }) => {
  const classes = useStyles();
  return <DialogActions className={classes.actions}>{children}</DialogActions>;
};
